import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import LocationFiltersEditor from "./LocationFiltersEditor";
import {
  DOCUMENT_LIBRARY_MAX_LOCATION_ROWS,
  isLocationFilterActive,
} from "../../utils/locationFilterUtils";

export default function DocumentLocationFilter({
  locationFilters,
  setLocationFilters,
}) {
  const isFilterActive = isLocationFilterActive(locationFilters);
  const allowMultiple = DOCUMENT_LIBRARY_MAX_LOCATION_ROWS > 1;

  // Match FiltersDropdown `useLargeScreenControls` (lg), not xl-only.
  return (
    <Popover className="relative hidden px-4 text-left lg:inline-block">
      <PopoverButton
        className={`group inline-flex items-center justify-center text-sm font-medium ${
          isFilterActive ? "text-indigo-700" : "text-gray-700"
        } hover:text-gray-900`}
      >
        <span>Location</span>
        {isFilterActive ? (
          <span className="ml-1.5 rounded bg-indigo-100 px-1.5 py-0.5 text-xs font-semibold tabular-nums text-indigo-700">
            1
          </span>
        ) : null}
        <ChevronDownIcon
          aria-hidden="true"
          className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
        />
      </PopoverButton>

      <PopoverPanel
        transition
        portal
        anchor="bottom end"
        className="z-[100] w-72 origin-top-right rounded-md bg-white p-4 shadow-2xl ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in sm:w-80"
      >
        <div className="space-y-3">
          <h3 className="text-sm font-medium text-gray-500">Location</h3>
          <LocationFiltersEditor
            locationFilters={locationFilters}
            setLocationFilters={setLocationFilters}
            layout="vertical"
            allowMultiple={allowMultiple}
          />
        </div>
      </PopoverPanel>
    </Popover>
  );
}
